import './../vendor/pushstream';
import getCustomLogger from './logger';

const logger = getCustomLogger('PushStream');

export default class Stream {
  constructor(host, port, channel, onUpdate, onError, onStarted) {
    // Status
    this.status = {
      CLOSED: 0,
      CONNECTING: 1,
      OPEN: 2,
    };

    this.host = host;
    this.port = port;
    this.channel = channel;
    this.options = {
      onUpdate,
      onError,
      onStarted,
    };

    this.maxErrors = 30;

    this.connect();
  }

  /**
   * Connect to the pushstream channel
   *
   * @memberof Stream
   */
  connect() {
    let pushstreamSettings = {
      host: this.host,
      port: this.port,
      longPollingInterval: 60000,
      // No iphone, depois de dormir ele reconecta com este timeout
      reconnectOnChannelUnavailableInterval: 1000,
      modes: 'websocket',
    };

    // eslint-disable-next-line no-undef
    this.client = new PushStream(pushstreamSettings);

    this.errorCount = 0;

    // Pushstream callbacks
    this.client.onmessage = this.onUpdate.bind(this);
    this.client.onerror = this.onError.bind(this);
    this.client.onstatuschange = this.onStatusChange.bind(this);

    this.client.addChannel(this.channel);

    this.client.connect();
  }

  /**
   * Close pushtream connection
   *
   * @memberof Stream
   */
  disconnect() {
    if (this.client) {
      this.client.disconnect();
      this.client = null;
    }
  }

  /**
   * Call when pushstream receve a new message
   *
   * @param {*} data
   * @memberof Stream
   */
  onUpdate(data) {
    this.options.onUpdate && this.options.onUpdate(data);
  }

  /**
   * Call if pushstream return an error
   *
   * @param {object} error
   * @memberof Stream
   */
  onError(error) {
    this.handleErrors(error);
  }

  /**
   * Call when pushstream status is changed
   *
   * status codes:
   * PushStream.CLOSED        = 0;
   * PushStream.CONNECTING    = 1;
   * PushStream.OPEN          = 2;
   *
   * @param {int} state
   * @memberof Stream
   */
  onStatusChange(state) {
    switch (state) {
    case (this.status.CLOSED, this.status.CONNECTING):
      this.errorCount > 1 && this.handleErrors(`PushStream Stopped - With State: ${state}`);
      break;
    case this.status.OPEN:
      logger.info(`PushStream Started - With State: ${state}`);
      this.options.onStarted && this.options.onStarted();
      break;
    }
  }

  /**
   * Handle error/status from pushstream
   *
   * @param {string} error
   * @memberof Stream
   */
  handleErrors(error) {
    if (this.errorCount > this.maxErrors) {
      logger.error('Stoping with error: ', error);
      this.disconnect();
      this.options.onError && this.options.onError();
    } else {
      this.errorCount++;
    }
  }
}
